import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./HeaderUser.css";
import { useGlobal } from "../../contexts/GlobalContext";
import { getProfilePicture } from "../../util/common";

function HeaderUser() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const { user, appMode, setAppMode } = useGlobal();

  const [profilePicture, setProfilePicture] = useState("");

  useEffect(() => {
    const loadProfilePicture = async () => {
      if (user?.ProfilePictureMedia) {
        const picture = await getProfilePicture(user.ProfilePictureMedia);
        setProfilePicture(picture);
      }
    };
    loadProfilePicture();
  }, [user?.ProfilePictureMedia]);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsDropdownOpen(false);
    }
  };

  const handleEditProfile = () => {
    navigate("/ViewProfile");
    setIsDropdownOpen(false);
  };

  const handleSwitchMode = () => {
    setAppMode(appMode === "admin" ? "employee" : "admin");
    localStorage.setItem("appMode", appMode === "admin" ? "employee" : "admin");
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="employee-header-user" ref={dropdownRef}>
      <div className="user-container" onClick={toggleDropdown}>
        <div className="user-details">
          <img src={profilePicture} alt="User" />
          <span>
            {user?.FirstName} {user?.MiddleName} {user?.LastName}
          </span>

          {appMode === "admin" && <span className="admin-pill">ADMIN</span>}
        </div>
        <i className="fa-solid fa-chevron-down"></i>
      </div>

      {isDropdownOpen && (
        <div className="user-dropdown">
          <button onClick={handleEditProfile}>
            <i className="fa-solid fa-user-pen"></i> View Profile
          </button>

          {true && (
            <>
              <div className="dropdown-divider" />
              <button onClick={handleSwitchMode} className="switch-role">
                <i className="fa-solid fa-shield-halved"></i>
                {appMode === "admin"
                  ? "Switch to Employee View"
                  : "Switch to Admin View"}
              </button>
            </>
          )}
          <button >
            <i className="fa-solid fa-right-from-bracket"></i> Logout
          </button>
        </div>
      )}
    </div>
  );
}

export default HeaderUser;
